<template>
  <div class="mb-16">
    <div class="flex flex-col md:flex-row gap-12 items-center mb-8">
      <!-- Image container -->
      <div class="w-full md:w-1/4">
        <img
          :src="require(`@/assets/images/affiliates/${affiliate.image}`)"
          :alt="`${affiliate.name.toUpperCase()}`"
          class="w-full h-auto object-cover rounded-lg"
        />
      </div>
      
      <!-- Text content -->
      <div class="w-full md:w-1/2 space-y-4 hyphens-auto">
        <div class="space-y-1">
          <h1 class="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 text-hyphen">
            {{ affiliate.name.toUpperCase() }}
          </h1>
        </div>
        
        <p class="text-gray-700 leading-relaxed max-w-lg">
          {{ affiliate.description }}
        </p>
      </div>

      <!-- External link column -->
      <div class="w-full md:w-1/4 mt-4 md:mt-0 flex items-center justify-start">
        <a 
          v-if="affiliate.websiteUrl"
          :href="affiliate.websiteUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-block text-gray-900 underline uppercase italic"
        >
          Visit {{ affiliate.name.toUpperCase() }}
        </a>
      </div>
    </div>
    
    <!-- Divider - only show if not last -->
    <hr v-if="!isLast" class="mt-12 border-t border-gray-200">
  </div>
</template>

<script>
  export default {
    name: 'AffiliateCard',
    props: {
      affiliate: {
        type: Object,
        required: true,
        validator(value) {
          return [
            'name',
            'description',
            'websiteUrl'
          ].every(prop => prop in value)
        }
      },
      isLast: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped>
  .text-hyphen {
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
</style> 